import { NgModule } from '@angular/core';
import { BehaviorTrackerScriptInjectorService } from 'app/behavior-tracking/behavior-tracker-script-injector.service';
import { BehaviorTrackerService } from 'app/behavior-tracking/behavior-tracker.service';
import { TrackBehaviorDirective } from 'app/behavior-tracking/directives/track-behavior.directive';
import { AdobeTrackingProviderService } from 'app/behavior-tracking/providers/adobe-tracking-provider.service';
import { GtmTrackingProviderService } from 'app/behavior-tracking/providers/gtm-tracking-provider.service';
import { PostHogTrackingProviderService } from 'app/behavior-tracking/providers/posthog-tracking-provider.service';
import { BEHAVIOR_TRACKING_PROVIDERS } from 'app/behavior-tracking/tokens/behavior-tracking.token';

@NgModule({
    imports: [TrackBehaviorDirective],
    exports: [TrackBehaviorDirective],
    providers: [
        BehaviorTrackerScriptInjectorService,
        BehaviorTrackerService,
        AdobeTrackingProviderService,
        GtmTrackingProviderService,
        PostHogTrackingProviderService,
        { provide: BEHAVIOR_TRACKING_PROVIDERS, useExisting: AdobeTrackingProviderService, multi: true },
        { provide: BEHAVIOR_TRACKING_PROVIDERS, useExisting: GtmTrackingProviderService, multi: true },
        { provide: BEHAVIOR_TRACKING_PROVIDERS, useExisting: PostHogTrackingProviderService, multi: true },
    ],
})
export class BehaviorTrackerModule {
}
